import { render, staticRenderFns } from "./PendingProfilesHome.vue?vue&type=template&id=18c29465&"
import script from "./PendingProfilesHome.vue?vue&type=script&lang=ts&"
export * from "./PendingProfilesHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports